module.exports = __webpack_public_path__ + "static/media/au.26b17d67.svg";